// Phase 3a: standalone parcel detail page (`/parcels/<uid>/`).
// The first parcel surface that lives outside any project context.
// Hosts the "Your scenarios on this parcel" rollup + the parcel-only
// Deal Calc entry point that feeds PR #67's standalone→project
// promotion flow.

export function init(..._args: Array<string>): void {
	document.body.classList.add('lb-redesign-body');
	if (document.getElementById('id_lb-parcel-detail')) {
		import('./view')
			.then(mod => (new mod.ParcelDetailPageView()));
	}
}
